export const sexes = {
    en: ['Female', 'Male', 'Other...'],
    hu: ['Nő', 'Férfi', 'Egyéb...']
}